import React, { useEffect } from "react";
import RequiredActions from "../components/dashboard/RequiredActions";
import TopBar from "../components/menu/TopBar";
import { useDispatch, useSelector } from "react-redux";
import PatientSearch from "./PatientSearch";
import ViewAllRequiredAction from "../components/dashboard/ViewAllRequiredAction";
import { setViewAllFlage } from '../stores/slices/requiredActionsSlice'

function Dashboard() {
  const dispatch = useDispatch();
  const browserToken = useSelector((state) => state.preAuthSlice.browserToken);
  const requirdActionsData = useSelector(
    (state) => state.requiredActionsSlice.requirdAction
  );
  useEffect(() => {
    dispatch(setViewAllFlage(false))
  }, []);

  return (
    <div className="content">
      <TopBar />
      <div className="grid columns-12 gap-6">
        <div className="g-col-12 ">
          <div className="grid columns-12 gap-6">
            {requirdActionsData?.viewAllFlage ? (
              <>
                <ViewAllRequiredAction />
              </>
            ) : (
              <>
                <PatientSearch value={false} />
                {/* <RequiredActions /> */}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
